<template>
  <div class="section">
    <div v-if="header != null" class="header">
      <div>{{header}}</div>
      <img v-if="tooltip != null" class="tooltip" src="/images/tooltip.svg" :title="tooltip" />
      <div v-if="optional != null" class="optional">İsteğe Bağlı</div>
    </div>
    <slot name="default" />
  </div>
</template>

<script>
export default {
  props: ["header", "tooltip", "optional"]
};
</script>

<style lang="scss" scoped>
.section {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.71;
  color: #696f89;
  margin-bottom: 30px;

  .header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 11px;
    font-weight: 600;
    line-height: 2.18;
    letter-spacing: 0.08px;
    color: #696f89;
    margin-bottom: -5px;

    .tooltip {
      width: 15px;
      margin-left: 4px;
    }

    .optional {
      font-weight: normal;
      margin-left: 6px;
      font-size: 11px;
      font-style: italic;
      line-height: 2.18;
      letter-spacing: 0.08px;
      color: var(--v-primary-base)
    }
  }
}
</style>